import { en_US } from '@shared/platform-core/public/locale/en_US.js';
import { zh_CN } from '@shared/platform-core/public/locale/zh_CN.js';
import { zh_HK } from '@shared/platform-core/public/locale/zh_HK.js';
import { en_US_shell } from './en_US_shell.js';
import { zh_CN_shell } from './zh_CN_shell.js';
import { zh_HK_shell } from './zh_HK_shell.js';

function loadLocale(lang) {
    let locale = null;
    let message = null;
    switch (lang) {
        case 'en':
            locale = 'en-US';
            message = Object.assign({}, en_US, en_US_shell);
            break;
        case 'cn':
            locale = 'zh-CN';
            message = Object.assign({}, zh_CN, zh_CN_shell);
            break;
        case 'hk':
            locale = 'zh-HK';
            message = Object.assign({}, zh_HK, zh_HK_shell);
            break;
        default:
            locale = 'en-US';
            message = Object.assign({}, en_US, en_US_shell);
            break;
    }
    return { locale, message };
}

export { loadLocale };
